import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { textBlue, textGray } from '@osmosis/tailwind-ui/styles/text';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { faSquareLeft } from '@fortawesome/pro-solid-svg-icons/faSquareLeft';
import { faSquareRight } from '@fortawesome/pro-solid-svg-icons/faSquareRight';
import { faSquareUp } from '@fortawesome/pro-solid-svg-icons/faSquareUp';
import { faSquareDown } from '@fortawesome/pro-solid-svg-icons/faSquareDown';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

import { KeyboardShortcut } from '../../context/VideoPlayerProvider';
import { getLocalizedProductComponents } from '../../constants';
import { keyboardShortcutsList } from '../../constants/formatMesage';

export type KeyProps = {
  shortcut: KeyboardShortcut;
};

const Key = (props: KeyProps) => {
  const { shortcut } = props;
  const icons: Record<string, IconDefinition> = {
    left: faSquareLeft,
    right: faSquareRight,
    up: faSquareUp,
    down: faSquareDown,
  };

  return (
    <P
      className={`!text-sm py-1 px-2 ${textGray} border rounded-[3px] border-inherit`}
    >
      {shortcut?.isIcon ? (
        <Icon icon={icons[shortcut.key]} size="xl" className={textBlue} />
      ) : (
        shortcut?.key
      )}
    </P>
  );
};

export type KeyboardShortcutsProps = {
  shortcuts: KeyboardShortcut[];
};

/**
 * KeyboardShortcuts.
 */
export default function KeyboardShortcuts({
  shortcuts,
}: KeyboardShortcutsProps): JSX.Element {
  const intl = useIntl();

  const localizedKeyboardShortcutsList = useMemo(
    () => getLocalizedProductComponents(intl, keyboardShortcutsList),
    [intl],
  );
  return (
    <Flex className="flex-col w-[240px] p-3">
      {shortcuts.map((shortcut) => {
        return (
          <Flex
            className=" items-center justify-between mb-1"
            key={shortcut.key}
          >
            <Key shortcut={shortcut} />
            <P className="!text-sm text-right">
              {localizedKeyboardShortcutsList[shortcut.description].title}
            </P>
          </Flex>
        );
      })}
    </Flex>
  );
}
